export default "__VITE_ASSET__Q8nUdnyW__"